import AbstractLazyLoad from "./AbstractLazyLoad";

export default class TrustpilotLazyLoad extends AbstractLazyLoad {
    constructor() {
        super('.trustpilot-widget');
    }

    protected load(): void {
        window['tpilot'] = {
            context: {
                id: '363d423c5493aaacbf39af591bdd8aa0',
            },
        };
        const scriptTag = document.createElement('script');
        scriptTag.async = true;
        scriptTag.src = '//widget.trustpilot.com/bootstrap/v5/tp.widget.bootstrap.min.js';
    
        const firstScriptTag = document.getElementsByTagName('script')[0];
        firstScriptTag.parentNode?.insertBefore(scriptTag, firstScriptTag);
    }
}
